import { render, staticRenderFns } from "./UserSysteamInterestInfo.vue?vue&type=template&id=f89e0f44&"
import script from "./UserSysteamInterestInfo.vue?vue&type=script&lang=js&"
export * from "./UserSysteamInterestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports